import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PopulationQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-mixed-loyalty-nav',
  templateUrl: './mixed-loyalty-nav.component.html',
  styleUrls: ['./mixed-loyalty-nav.component.scss'],
})
export class MixedLoyaltyNavComponent implements OnInit {
  isCorporate: boolean;
  isKid: boolean;
  population = Populations;

  screenType = ScreenType;

  constructor(
    private populationQuery: PopulationQuery,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.isCorporate = this.populationQuery.userInPopulation([this.population.Hospitality]);
    this.isKid = this.populationQuery.userInPopulation([this.population.JuniorBluebirds]);
  }

  isActive(url: string): boolean {
    // Check if the route contains query params.
    const hasQueryParams = Object.keys(this.route.snapshot.queryParams)?.length > 0;
    return this.router.isActive(url, true) || (this.router.isActive(url, false) && hasQueryParams);
  }
}
